if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    connectedCallback() {
      document.querySelectorAll('quick-add-modal').forEach((modal) => {
        if (modal !== this && modal.id === this.id && modal.parentElement === document.body) {
          modal.remove();
        }
      });
      super.connectedCallback();
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      document.body.classList.remove('quick-add-open');
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      const errorMessage = this.querySelector('[data-quick-add-error]');
      if (errorMessage) errorMessage.hidden = true;
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => {
          if (!response.ok) throw new Error(`Quick add request failed (${response.status})`);
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) throw new Error('Quick add response is missing product content');
          this.prepareCompactProduct();
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          this.prepareMobileActions();

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          document.body.classList.add('quick-add-open');
          super.show(opener);
        })
        .catch((error) => {
          console.error(error);
          if (errorMessage) {
            errorMessage.hidden = false;
            document.body.classList.add('quick-add-open');
            super.show(opener);
            errorMessage.focus();
          }
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    prepareCompactProduct() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const productInfo = this.productElement.querySelector('.product__info-container');
      if (!productInfo) return;

      /* Quick View sert uniquement à voir, choisir et ajouter. Les blocs PDP
         longs ou marketing ne sont pas injectés dans la modale. */
      Array.from(productInfo.children).forEach((child) => {
        const isEssential = child.matches(
          '.product__title, .product-page-price, .product__inventory, ' +
          'variant-radios, variant-selects, .product__view-details'
        ) || child.querySelector(':scope > product-form');

        if (!isEssential) child.remove();
      });

      this.productElement.querySelectorAll(
        '.shopify-payment-button, .sticky-atc, .payment-badges-block, ' +
        '.quantity-breaks-container, .product-form__quantity, ' +
        '[id^="shopify-block-"], .shopify-app-block'
      ).forEach((element) => element.remove());
    }

    prepareMobileActions() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const productForm = this.modalContent.querySelector('product-form');
      if (!productForm?.parentElement) return;

      productForm.parentElement.classList.add('quick-add-modal__actions');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
